type CategoryCardProps = {
  children: React.ReactNode
  className?: string
};

export const CategoryCard = ({ children, className }: CategoryCardProps) => {
  return (
    <div className={`h-full rounded-xl ${className}`}>{children}</div>
  );
};
